
// @ts-nocheck
import locale_da_45DK_46js_0f480c2a from "#nuxt-i18n/0f480c2a";
import locale_no_45NO_46js_8c122dea from "#nuxt-i18n/8c122dea";
import locale_sv_45SE_46js_19af65e3 from "#nuxt-i18n/19af65e3";

export const localeCodes =  [
  "da",
  "no",
  "sv"
]

export const localeLoaders = {
  da: [
    {
      key: "locale_da_45DK_46js_0f480c2a",
      load: () => Promise.resolve(locale_da_45DK_46js_0f480c2a),
      cache: true
    }
  ],
  no: [
    {
      key: "locale_no_45NO_46js_8c122dea",
      load: () => Promise.resolve(locale_no_45NO_46js_8c122dea),
      cache: true
    }
  ],
  sv: [
    {
      key: "locale_sv_45SE_46js_19af65e3",
      load: () => Promise.resolve(locale_sv_45SE_46js_19af65e3),
      cache: true
    }
  ]
}

export const vueI18nConfigs = [
  () => import("#nuxt-i18n/95a1897c" /* webpackChunkName: "config_i18n_46config_46ts_95a1897c" */)
]

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      domain: "fodboldpakker.dk",
      code: "da",
      iso: "da-DK",
      currency: "DKK",
      country: "Denmark",
      country_iso: "DK",
      flag: "🇩🇰",
      files: [
        {
          path: "/home/prod/v3/i18n/lang/da-DK.js",
          cache: undefined
        }
      ]
    },
    {
      domain: "fotballpakker.no",
      code: "no",
      iso: "no-NO",
      currency: "NOK",
      country: "Norway",
      country_iso: "NO",
      flag: "🇳🇴",
      files: [
        {
          path: "/home/prod/v3/i18n/lang/no-NO.js",
          cache: undefined
        }
      ]
    },
    {
      domain: "footballtrips.se",
      code: "sv",
      iso: "sv-SE",
      currency: "SEK",
      country: "Sweden",
      country_iso: "SE",
      flag: "🇸🇪",
      files: [
        {
          path: "/home/prod/v3/i18n/lang/sv-SE.js",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "da",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "no_prefix",
  lazy: false,
  langDir: "lang",
  rootRedirect: undefined,
  detectBrowserLanguage: false,
  differentDomains: true,
  baseUrl: "",
  customRoutes: "config",
  pages: {
    "gift-card/index": {
      da: "/gavekort",
      no: "/gavekort",
      sv: "/presentkort",
      en: "/gift-card"
    },
    "residual-sale/index": {
      da: "/restsalg",
      no: "/restsalg",
      sv: "/restsalg",
      en: "/residual-sale"
    },
    "packages/index": {
      da: "/pakker",
      no: "/pakker",
      sv: "/paket",
      en: "/packages"
    },
    "packages/[slug]/index": {
      da: "/pakker/[slug]",
      no: "/pakker/[slug]",
      sv: "/paket/[slug]",
      en: "/packages/[slug]"
    },
    "packages/[slug]/book": {
      da: "/pakker/[slug]/book",
      no: "/pakker/[slug]/book",
      sv: "/paket/[slug]/book",
      en: "/packages/[slug]/book"
    },
    "packages/[slug]/preorder": {
      da: "/pakker/[slug]/preorder",
      no: "/pakker/[slug]/preorder",
      sv: "/paket/[slug]/preorder",
      en: "/packages/[slug]/preorder"
    },
    "offer/[slug]": {
      da: "/tilbud/[slug]",
      no: "/tilbud/[slug]",
      sv: "/tilbud/[slug]",
      en: "/offer/[slug]"
    },
    "invoice/index": {
      da: "/faktura",
      no: "/faktura",
      sv: "/faktura",
      en: "/invoice"
    },
    "invoice/[slug]": {
      da: "/faktura/[slug]",
      no: "/faktura/[slug]",
      sv: "/faktura/[slug]"
    },
    "football-trips/[slug]": {
      da: "/fodboldrejser/[slug]",
      no: "/fotballreiser/[slug]",
      sv: "/fotbollsresor/[slug]",
      en: "/football-trips/[slug]"
    },
    "clubs/index": {
      da: "/klubber",
      no: "/klubber",
      sv: "/klubbar",
      en: "/clubs"
    },
    "info/index": {
      da: "/info",
      no: "/info",
      sv: "/info",
      en: "/info"
    },
    "info/[slug]": {
      da: "/info/[slug]",
      no: "/info/[slug]",
      sv: "/info/[slug]",
      en: "/info/[slug]"
    },
    "info/about": {
      da: "/info/om-os",
      no: "/info/om-os",
      sv: "/info/om-oss",
      en: "/info/about"
    },
    "info/profession": {
      da: "/info/erhverv",
      no: "/info/virksomhet",
      sv: "/info/företag",
      en: "/info/profession"
    },
    "blog/index": {
      da: "/blog",
      no: "/blog",
      sv: "/blog",
      en: "/blog"
    },
    "blog/[slug]": {
      da: "/blog/[slug]",
      no: "/blog/[slug]",
      sv: "/blog/[slug]",
      en: "/blog/[slug]"
    }
  },
  skipSettingLocaleOnNavigate: true,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    domain: "fodboldpakker.dk",
    code: "da",
    iso: "da-DK",
    currency: "DKK",
    country: "Denmark",
    country_iso: "DK",
    flag: "🇩🇰",
    files: [
      {
        path: "/home/prod/v3/i18n/lang/da-DK.js",
        cache: undefined
      }
    ]
  },
  {
    domain: "fotballpakker.no",
    code: "no",
    iso: "no-NO",
    currency: "NOK",
    country: "Norway",
    country_iso: "NO",
    flag: "🇳🇴",
    files: [
      {
        path: "/home/prod/v3/i18n/lang/no-NO.js",
        cache: undefined
      }
    ]
  },
  {
    domain: "footballtrips.se",
    code: "sv",
    iso: "sv-SE",
    currency: "SEK",
    country: "Sweden",
    country_iso: "SE",
    flag: "🇸🇪",
    files: [
      {
        path: "/home/prod/v3/i18n/lang/sv-SE.js",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/